import { Gastito } from './../../jorge/jorge.component';
import { Component, ElementRef, ViewChild, OnInit, Input } from '@angular/core';
import {SelectionModel} from '@angular/cdk/collections';
import { Router } from '@angular/router';
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { GlobalPositionStrategy } from '@angular/cdk/overlay';
import { formatDate, DatePipe } from '@angular/common';
import {MatPaginatorModule, MatPaginator, MatSort, MatTableDataSource, MatDialog} from '@angular/material';
import {MatSnackBar} from '@angular/material';

export interface PeriodicElement {
  position:number;
  COD_CUENTA: string;
  DETALLE: string;
  SUBTOT: string;
}

var ELEMENT_DATA: PeriodicElement[] = [];

/**
 * @title Table with filtering
 */

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.css']
})
export class PrintComponent implements OnInit {
  @ViewChild('TABLE') table: ElementRef;
  displayedColumns: string[] = ['select','COD_CUENTA', 'DETALLE', 'SUBTOT'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selection = new SelectionModel<PeriodicElement>(true, []);

  //para getear localst

  codopago;
  codcheque;
  codcuenta;
  fechahoy;
  loading;

  dataSourcePago;
  dataSourceUser;
  
  //datos de PAGO
  be_op;
  be_cheque;
  be_conc;
  be_banco;
  be_cuenta;
  be_fechapago;
  be_leyenda;
  be_total_pago;

  //cuantos gastos trae el array de jorge
  cantgastos = localStorage.getItem('contGastos');
  //solo trae los codgasto de los array
  arrgastos = localStorage.getItem('strGastos');
  //trae el array completo desde jorge para el pago y los datos
  //arrCompleto = JSON.parse(localStorage.getItem('arrComp'));
  sumagastos = localStorage.getItem('sumaGastos');

  montoescrito;

  constructor(
    private router: Router,
    private http: HttpClient,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    public snackBar: MatSnackBar
    ) {
      this.loading=true
    }

    poner(){
      let data = { position: 2 , COD_CUENTA: '415800-0', DETALLE: 'Cochera', SUBTOT: '3250'};
      ELEMENT_DATA.push(data);
      this.dataSource = new MatTableDataSource(ELEMENT_DATA);
    
    }

  codo;
  buscarOP(arr){
    this.arrgastos = arr;
    console.log("generando op de..: " + arr);
    this.getDatosGastos(arr);
    this.getDatosPago(arr);
    this.getDatosUser(arr);
  }

  userlog;
  ngOnInit() {
    this.userlog = localStorage.getItem("userId");
    window.scroll(0,0);
    //console.log(this.cantgastos);
    console.log(this.arrgastos);
    this.getDatosGastos(this.arrgastos);
    this.getDatosPago(this.arrgastos);
    this.getDatosUser(this.arrgastos);

  }

  getDatosGastos(codigos){
    codigos = this.arrgastos;
    this.loading=true;
    //http://localhost:1337/api/print/datogastos?codgas=214,215,216,217,218 -- var sql = `call sg_print_opgastos('${codgas}')`
    this.http.get(`${environment.backendUrl}/api/print/datogastos?codgas=${codigos}`)
      .subscribe((data: any[]) => {
        this.dataSource.data = data;
        console.log("*detalle gastos");
        console.log(this.dataSource.data);
        this.loading=false;     
      });
  }

  getDatosPago(codigos){
    codigos = this.arrgastos;
    this.loading=true;
    //http://localhost:1337/api/print/datopago?codgas=214,215,216,217,218 -- var sql = `call sg_print_opdatos('${codgas}')`
    this.http.get(`${environment.backendUrl}/api/print/datopago?codgas=${this.arrgastos}`)
      .subscribe((data2: any[]) => {
        this.dataSourcePago = data2[0];
        console.log("*dato pago");
        console.log(this.dataSourcePago);
        this.be_op = this.dataSourcePago["COD_PAGO"];
        this.be_cheque = this.dataSourcePago["COD_OPERACION"];
        this.be_banco = this.dataSourcePago["COD_BANCO"];
        this.be_fechapago = this.datePipe.transform(this.dataSourcePago["FECHA_PAGO"],"yyyy-MM-dd");
        this.be_leyenda = this.dataSourcePago["LEYENDA"];
        this.be_total_pago = this.dataSourcePago["TOTAL"];
        // montoescrito 1
        this.montoescrito= this.numeroALetras(this.be_total_pago, {
          plural: 'Pesos Argentinos',
          singular: 'Peso Argentino',
          centPlural: 'centavos',
          centSingular: 'centavo'
        })
        console.log(this.montoescrito);        
        console.log("Pago nro:" + this.be_op + " cod_operacion: " + this.be_cheque + " cod_banco: " + this.be_banco + " fechapago: " + this.be_fechapago + " leyenda: " + this.be_leyenda); 
        this.loading=false;     
      });

  }
  usuarios;
  seccional;
  getDatosUser(codigos){
    codigos = this.arrgastos;
    this.loading=true;
    //http://localhost:1337/api/print/datouser?codgas=214,215,216,217,218 -- var sql = `call sg_print_opdatosuser('${codgas}')`
    this.http.get(`${environment.backendUrl}/api/print/datouser?codgas=${this.arrgastos}`)
      .subscribe((data3: any[]) => {
        this.dataSourceUser = data3;
        console.log("*dato user");
        console.log(this.dataSourceUser);
        console.log("user parseados..")
        this.usuarios = [];
        for (var _i = 0; _i < data3.length; _i++) {
          var usr = this.dataSourceUser[_i]["NOMBRE"];
          //console.log(cod);
          if (usr){
            this.usuarios.splice(0, 0, usr);
          }
        }
        this.usuarios = JSON.stringify(this.usuarios);
        console.log(this.usuarios);

        this.seccional = this.dataSourceUser[0]["SEC"];      
        console.log("sec:" + this.seccional);
        this.loading=false;     
      });
  }
  /*
  getDatosPago(){
    this.loading=true;
    //http://localhost:1337/api/print/pri?codgas=65 -- var sql = `call sg_print_opgastos('${codgas}')`
    this.http.get(`${environment.backendUrl}/api/print/pri?codgas=${this.arrgastos}`)
      .subscribe((data: any[]) => {
        //chupa los datos de pago
        this.dataSourcePago = data[0]; 
        //chupa los datos del gasto para el grid
        this.dataSource.data = data;
        console.log(`BACKEND: ${this.dataSourcePago["DETALLE"]}`);
        //lleno datos pago con resultado api
        this.be_op = this.dataSourcePago["PAGONRO"];
        this.be_cheque = this.dataSourcePago["COD_CHEQUE"];
        this.be_conc = this.dataSourcePago["COD_CONCEPTO"];
        this.be_cuenta = this.dataSourcePago["COD_BANCO"];
        this.be_fechapago = this.datePipe.transform(this.dataSourcePago["FECHA_PAGO"],"yyyy-MM-dd");
        
        console.log(`${this.be_op},${this.be_cheque},${this.be_conc},${this.be_cuenta},${this.be_fechapago}`);
        
        this.loading=false; 
  
      });
    console.log("listado de pagos cargado!");
  }
*/
 
  print(){
    window.print()
  }  

  return(){
    this.router.navigate(['/vergastos-jorge']);
  }

  numeroALetras = (function() {

    // Código basado en https://gist.github.com/alfchee/e563340276f89b22042a
        function Unidades(num){
    
            switch(num)
            {
                case 1: return 'UN';
                case 2: return 'DOS';
                case 3: return 'TRES';
                case 4: return 'CUATRO';
                case 5: return 'CINCO';
                case 6: return 'SEIS';
                case 7: return 'SIETE';
                case 8: return 'OCHO';
                case 9: return 'NUEVE';
            }
    
            return '';
        }//Unidades()
    
        function Decenas(num){
    
            let decena = Math.floor(num/10);
            let unidad = num - (decena * 10);
    
            switch(decena)
            {
                case 1:
                    switch(unidad)
                    {
                        case 0: return 'DIEZ';
                        case 1: return 'ONCE';
                        case 2: return 'DOCE';
                        case 3: return 'TRECE';
                        case 4: return 'CATORCE';
                        case 5: return 'QUINCE';
                        default: return 'DIECI' + Unidades(unidad);
                    }
                case 2:
                    switch(unidad)
                    {
                        case 0: return 'VEINTE';
                        default: return 'VEINTI' + Unidades(unidad);
                    }
                case 3: return DecenasY('TREINTA', unidad);
                case 4: return DecenasY('CUARENTA', unidad);
                case 5: return DecenasY('CINCUENTA', unidad);
                case 6: return DecenasY('SESENTA', unidad);
                case 7: return DecenasY('SETENTA', unidad);
                case 8: return DecenasY('OCHENTA', unidad);
                case 9: return DecenasY('NOVENTA', unidad);
                case 0: return Unidades(unidad);
            }
        }//Unidades()
    
        function DecenasY(strSin, numUnidades) {
            if (numUnidades > 0)
                return strSin + ' Y ' + Unidades(numUnidades)
    
            return strSin;
        }//DecenasY()
    
        function Centenas(num) {
            let centenas = Math.floor(num / 100);
            let decenas = num - (centenas * 100);
    
            switch(centenas)
            {
                case 1:
                    if (decenas > 0)
                        return 'CIENTO ' + Decenas(decenas);
                    return 'CIEN';
                case 2: return 'DOSCIENTOS ' + Decenas(decenas);
                case 3: return 'TRESCIENTOS ' + Decenas(decenas);
                case 4: return 'CUATROCIENTOS ' + Decenas(decenas);
                case 5: return 'QUINIENTOS ' + Decenas(decenas);
                case 6: return 'SEISCIENTOS ' + Decenas(decenas);
                case 7: return 'SETECIENTOS ' + Decenas(decenas);
                case 8: return 'OCHOCIENTOS ' + Decenas(decenas);
                case 9: return 'NOVECIENTOS ' + Decenas(decenas);
            }
    
            return Decenas(decenas);
        }//Centenas()
    
        function Seccion(num, divisor, strSingular, strPlural) {
            let cientos = Math.floor(num / divisor)
            let resto = num - (cientos * divisor)
    
            let letras = '';
    
            if (cientos > 0)
                if (cientos > 1)
                    letras = Centenas(cientos) + ' ' + strPlural;
                else
                    letras = strSingular;
    
            if (resto > 0)
                letras += '';
    
            return letras;
        }//Seccion()
    
        function Miles(num) {
            let divisor = 1000;
            let cientos = Math.floor(num / divisor)
            let resto = num - (cientos * divisor)
    
            let strMiles = Seccion(num, divisor, 'UN MIL', 'MIL');
            let strCentenas = Centenas(resto);
    
            if(strMiles == '')
                return strCentenas;
    
            return strMiles + ' ' + strCentenas;
        }//Miles()
    
        function Millones(num) {
            let divisor = 1000000;
            let cientos = Math.floor(num / divisor)
            let resto = num - (cientos * divisor)
    
            let strMillones = Seccion(num, divisor, 'UN MILLON DE', 'MILLONES DE');
            let strMiles = Miles(resto);
    
            if(strMillones == '')
                return strMiles;
    
            return strMillones + ' ' + strMiles;
        }//Millones()
    
        return function NumeroALetras(num, currency) {
            currency = currency || {};
            let data = {
                numero: num,
                enteros: Math.floor(num),
                centavos: (((Math.round(num * 100)) - (Math.floor(num) * 100))),
                letrasCentavos: '',
                letrasMonedaPlural: currency.plural || 'PESOS CHILENOS',//'PESOS', 'Dólares', 'Bolívares', 'etcs'
                letrasMonedaSingular: currency.singular || 'PESO CHILENO', //'PESO', 'Dólar', 'Bolivar', 'etc'
                letrasMonedaCentavoPlural: currency.centPlural || 'CHIQUI PESOS CHILENOS',
                letrasMonedaCentavoSingular: currency.centSingular || 'CHIQUI PESO CHILENO'
            };
    
            if (data.centavos > 0) {
                data.letrasCentavos = 'CON ' + (function () {
                        if (data.centavos == 1)
                            return Millones(data.centavos) + ' ' + data.letrasMonedaCentavoSingular;
                        else
                            return Millones(data.centavos) + ' ' + data.letrasMonedaCentavoPlural;
                    })();
            };
    
            if(data.enteros == 0)
                return 'CERO ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos;
            if (data.enteros == 1)
                return Millones(data.enteros) + ' ' + data.letrasMonedaSingular + ' ' + data.letrasCentavos;
            else
                return Millones(data.enteros) + ' ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos;
        };
    
    })();
    
    
}
